<template>
  <div class="page">
      <div class="d_c">
        <p>充值信息</p>
        <span class="rt-pos" @click="goBack()"></span>
      </div>
      <div class="d_nei">
        <p class="d_p">
          <span>业务号：</span><span class="p_c">{{propsParams.msisdn}}</span>
        </p>
        <p>
          <span>ICCID：</span><span class="p_c">{{propsParams.iccid}}</span>
        </p>
        <p>
          <span>套餐名：</span><span class="p_c">{{propsParams.productName}}</span>
        </p>
        <p>
          <span>生效日期：</span><span class="p_c">{{propsParams.entryTime}}</span>
        </p>
        <p>
          <span>有效期：</span><span class="p_c">{{propsParams.validTime}}</span>
        </p>
        <p>
          <span>流量：</span><span class="p_c">{{propsParams.totalFlow}}</span>
        </p>
        <p>
          <span>价格：</span><span class="p_c"> {{'¥'+ propsParams.price}}</span>
        </p>
        <div class="d_phone" v-if="propsParams.showPhone == '1' && !initPhone">
          <nut-textinput placeholder="请输入联系电话" v-model="propsParams.phone" type="tel" maxlength="11"/>
          <nut-textinput placeholder="请输入验证码" v-model="propsParams.code" type="tel" maxlength="4"/>
          <div class="input-code">
            <span v-show="show" @click="getCode" class="opt-a">获取验证码</span>
            <span v-show="!show" class="count opt-a">{{count}}s后可重发</span>
          </div>
        </div>
        <div class="wenxin">
          <div class="p1">套餐说明：</div>
          <div class="p2">{{propsParams.description}}</div>
        </div>
      </div>
      <form name="form"></form> 
      <div class="footer">
        <nut-button @click="pay()">立即订购</nut-button>
      </div>
  </div>
</template>

<script>

import { wx_productDetail } from "@/api/api.js"; //获取套餐列表
import wx from "weixin-js-sdk";
import { wx_Auth } from "@/api/api.js"; //获取微信信息
import { wx_pay } from "@/api/api.js"; //微信支付
import { wx_sendOrderSms } from "@/api/api.js"; //发送验证码

export default {
  data() {
    return {
      propsParams:{},
      phone:"",
      code:"",
      iccid:this.$route.query.iccid,
      initPhone: true,
      // 倒计时的显示
      show: true,
      count: "",
      timer: null,
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    // 获取验证码
    getCode(){
      let params={
        phone: this.propsParams.phone
      }
      wx_sendOrderSms(params).then(res=>{
        if(res.data.code == 200){
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      })
    },
    //获取微信信息
    handelWxConfig() {
      let params = {
        url: window.location.href,
        channel:localStorage.getItem("channel")
      };
      wx_Auth(params).then(res => {
        let dataObj = res.data.data;
        this.datas = res.data.data;
        let getAppid = dataObj.appId;
        let getTimestamp = dataObj.timestamp;
        let getNonceStr = dataObj.nonceStr;
        let getSignature = dataObj.signature;
        wx.config({
          debug: false,
          appId: getAppid,
          timestamp: getTimestamp,
          nonceStr: getNonceStr,
          signature: getSignature,
          jsApiList: ["chooseWXPay"]
        });
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["chooseWXPay"],
            success: function(res) {}
          });
        });
      });
    },
    // 判断是否是微信浏览器
    isWeiXin() {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    // 获取确认信息
    getPackage(){
      this.$toast.loading('加载中...',{ 
        duration:500,
        coverColor: "rgba(0,0,0,0.5)",
        closeOnClickOverlay: true,
        loadingRotate:true
      });
      let params ={
        id:this.$route.query.id || sessionStorage.getItem("id"),
        type:this.$route.query.type || sessionStorage.getItem("type"),
        iccid:this.$route.query.iccid || sessionStorage.getItem("iccid")
      }
      wx_productDetail(params).then(res => {
        if(res.data.code == 200){
          this.propsParams = res.data.data;
          this.initPhone = this.propsParams.phone;
          this.propsParams.entryTime = "立即生效";
          this.propsParams.validTime = this.propsParams.validTime.substr(0,10);
          if(this.propsParams.description){
            this.propsParams.description = res.data.data.description.replace(/[\r\n]/g,'\n')
          }
        }
      })
    },
    // 充值
    pay(){
      if(this.propsParams.showPhone == '1' &&  this.propsParams.phone.length != 11){
        this.$toast.warn('请输入正确联系方式');
      }else{
        let params ={
          iccid:this.propsParams.iccid,
          price:this.propsParams.price,
          productId:this.propsParams.productId,
          phone:this.propsParams.phone,
          verCode:this.propsParams.code,
          ip:"11.28.33.12",
          appId:sessionStorage.getItem("wechatId") || this.propsParams.appId,
          pid:sessionStorage.getItem("packageId") || this.$route.query.packageId
        }
        if(this.isWeiXin()){
          this.handelWxConfig();
          params.code = this.getUrlParam("code");
          params.type = "JSAPI";
          params.channel = localStorage.getItem("channel")
        }else{
          params.type = "MWEB";
          params.userId = sessionStorage.getItem("userId");
        }
        let that = this;
        wx_pay(params).then(res=>{
          if (res.data.code == 200) {
            if(this.isWeiXin()){
              wx.chooseWXPay({
                timestamp: res.data.data.timeStamp,
                nonceStr: res.data.data.nonceStr, 
                package: res.data.data.packageValue, 
                signType: res.data.data.signType, 
                paySign: res.data.data.paySign, 
                success: function(res) {
                  window.location.href =  `/dist/?code=${localStorage.getItem('code')}&state=1#/info?iccid=${that.propsParams.iccid}`
                }
              })
            }else{
              document.form.method= "post";     
              document.form.action= res.data.data.mwebUrl;
              document.form.submit(); 
            }
          }else{
            this.$toast.fail(res.data.message);
          }
        })
      }
    },
    //微信统一下单
    wxUnifiedorder(obj){
      //微信统一下单
      api.wxUnifiedorder(obj).then(res=>{
        if(res.returnCode == 200){//成功
          console.log('微信支付接口之前先生成签名成功',res)
          if(res.data.prepayId !=null){
            var appId = res.data.appId;//appId
            var nonceStr = res.data.nonceStr;//随机串
            var outTradeNo = res.data.out_trade_no;//保存订单号信息
            var packageStr = res.data.package;
            var paySign = res.data.paySign;//签名
            var prepayId = res.data.prepayId;//
            var signType = res.data.signType;//
            var timeStamp = res.data.timeStamp;//时间戳

            console.log("outTradeNo",outTradeNo)

            //支付
            wx.requestPayment({
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: packageStr,
              signType: signType,
              paySign: paySign,
              success (res1) {
                console.log('requestPayment',res1)
                if(res1.errMsg=="requestPayment:ok"){
                  //支付成功，跳转订单列表
                  // 进入我的订单 0：全部 1：待支付 2：已支付 3：已取消 4：免费课程
                  var type = 2;
                  wx.navigateTo({ url: '/pages/packageMy/my-order/my-order?type='+type });

                }else{
                  var type = 1;
                  wx.navigateTo({ url: '/pages/packageMy/my-order/my-order?type='+type });
                }
              },
              fail (res1){
                var type = 1;
                wx.navigateTo({ url: '/pages/packageMy/my-order/my-order?type='+type });
              }
            })
          }

        }
      })
    },
    //随机数生成
    getRandomNum(Min,Max){
      var Range = Max - Min;
      var Rand = Math.random();
      return(Min + Math.round(Rand * Range));
    },
    // 获取url的code
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let url = window.location.href;
      let search = url.split("?")[1];
      if (search) {
        var r = search.substr(0).match(reg);
        if (r !== null) return unescape(r[2]);
        return null;
      } else {
        return null;
      }
    },
  },
  created() {

  },
  mounted(){
    window.document.title = "确认订单";
    this.getPackage();
  },
};
</script>
<style scoped lang="less">
  .page{
    .d_c{
      width: 100%;
      height: 180px;
      background: #F94040;
      z-index: 1;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
      p{
        font-size: 22px;
        text-align: center;
        color: #fff;
        padding-top: 35px;
      }
    }
    .d_nei{
      width: 95%;
      background: #fff;
      margin: 0 auto;
      z-index: 22;
      position: relative;
      top: -100px;
      padding: 5px;
      p{
        font-size: 14px;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        .p_c{
          color: #F94040;
        }
      }
    }
    .d_phone{
      width: 85%;
      margin: 0 auto;
      position: relative;
      /deep/ .nut-textinput input{
        width: 100%;
        margin-top: 10px;
        border: 2px solid #F94040;
        color: #999;
        font-size: 14px;
      }
    }
    .input-code {
      position: absolute;
      right: 15px;
      top: 65%;
      height: 30px;
      .opt-a {
        display: block;
        width: 75px;
        height: 30px;
        line-height: 30px;
        background: #F94040;
        color: #fff;
        font-size: 12px;
        text-align: center;
      }
    }
    .wenxin{
      margin-top: 25px;
      padding: 10px;
      .p1{
        color: #F94040;
        font-size: 14px;
      }
      .p2{
        margin-top: 5px;
        white-space: pre-wrap;
      }
    }
    .footer{
      background: #F8F8F8;
      padding: 15px 0;
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 23;
      button{
        border-radius: 10px;
        width: 52%;
        font-size: 14px;
        height: 45px;
        line-height: 45px;
        border: 1px solid #F94040 !important;
      }
    }
    /deep/ .nut-textinput-clear{
      display: none;
    }
  }
</style>


